import i18n from 'i18next';

import { fspCompstatsApi, fspMatchstatsApi } from 'api/fspApi';
import store from 'store/configureStore';
import type { StatDefinition } from 'types/ApiResponseInterfaces';

const translateWithDefinitions = (statName: string, definitions: StatDefinition[] | undefined): string => {
  if (!definitions) return statName;

  const definition = definitions.find((def) => def.name === statName);
  if (!definition) return statName;

  const lang = i18n.language.toUpperCase();
  return definition.translations.name[lang] ?? definition.translations.name['EN'] ?? statName;
};

export const translateCompStatName = (statName: string): string => {
  const result = fspCompstatsApi.endpoints.getDefinitions.select()(store.getState());
  return translateWithDefinitions(statName, result.data);
};

export const translateMatchStatName = (statName: string): string => {
  const result = fspMatchstatsApi.endpoints.getMatchStatDefinitions.select()(store.getState());
  return translateWithDefinitions(statName, result.data);
};
